export default __webpack_public_path__ + "f04a031.png";